const menuToggle = document.querySelector("[data-menu-toggle]");
const mobileMenu = document.querySelector("[data-mobile-menu]");

const easeElements = [...document.querySelectorAll(".ease")];
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const playerScripts = new Map();

const announcement = document.querySelector("[data-announcement]");
const announcementClose = announcement?.querySelector("[data-announcement-close]");
announcementClose?.addEventListener("click", () => {
	try {
		localStorage.setItem("kickon-dismissed-announcement", announcement.dataset.announcementId || "");
	} catch (error) {
		// The banner still closes when browser storage is unavailable.
	}
	document.documentElement.classList.add("announcement-dismissed");
	announcement.remove();
});

const normaliseHostname = (hostname) => hostname.toLowerCase().replace(/^www\./, "");
const prepareExternalLinks = (scope = document) => {
	const links = scope.matches?.("a[href]") ? [scope] : [];
	links.push(...(scope.querySelectorAll?.("a[href]") || []));

	links.forEach((link) => {
		let url;
		try {
			url = new URL(link.getAttribute("href"), document.baseURI);
		} catch {
			return;
		}

		if (!["http:", "https:"].includes(url.protocol) || normaliseHostname(url.hostname) === normaliseHostname(window.location.hostname)) return;

		link.target = "_blank";
		const rel = new Set(link.rel.split(/\s+/).filter(Boolean));
		rel.add("noopener");
		rel.add("noreferrer");
		link.rel = [...rel].join(" ");
	});
};

prepareExternalLinks();
new MutationObserver((mutations) => {
	mutations.forEach((mutation) => {
		mutation.addedNodes.forEach((node) => {
			if (node.nodeType === Node.ELEMENT_NODE) prepareExternalLinks(node);
		});
	});
}).observe(document.body, { childList: true, subtree: true });

const contextualEnquiryTarget = document.getElementById("enquire") || document.getElementById("message");
if (contextualEnquiryTarget) {
	document.querySelectorAll("a.site-header__booking, .mobile-menu__booking-menu a").forEach((link) => {
		if (!/enquir/i.test(link.textContent)) return;
		link.setAttribute("href", `#${contextualEnquiryTarget.id}`);
		link.removeAttribute("target");
		link.removeAttribute("rel");
	});
}

const loadPlayerScript = (source) => {
	if (!source) return Promise.reject(new Error("Streaming player URL is missing."));
	if (playerScripts.has(source)) return playerScripts.get(source);

	const promise = new Promise((resolve, reject) => {
		const script = document.createElement("script");
		script.src = source;
		script.async = true;
		script.onload = resolve;
		script.onerror = () => reject(new Error(`Unable to load streaming player: ${source}`));
		document.head.append(script);
	});
	playerScripts.set(source, promise);
	return promise;
};

const compactHeroFollowupHeadings = [...document.querySelectorAll(".hero--height-compact")]
	.map((hero) => hero.nextElementSibling?.querySelector("h1, h2, h3, h4")?.closest(".ease"))
	.filter(Boolean);

const initialiseFormSelects = (scope = document) => {
	scope.querySelectorAll(".gform_wrapper select").forEach((select) => {
		if (!select.dataset.initialValue) select.dataset.initialValue = select.value;
		select.classList.toggle("has-selection", select.value !== "");
	});
};

const initialiseFormDatepickers = (scope = document) => {
	if (!window.jQuery?.fn?.datepicker) return;

	scope.querySelectorAll(".kickon-event-date input.gform-datepicker, .kickon-quote-event-date input.gform-datepicker, .kickon-event-quote--legacy .gfield--type-date input.gform-datepicker").forEach((input) => {
		// Gravity Forms 3+ supplies its own accessible datepicker via Apex4X. Let
		// it own modern fields, but retain our jQuery UI fallback for imported
		// legacy quote forms where the picker is lost between multi-page steps.
		if (window.$A?.setDatepicker && !input.closest(".kickon-event-quote--legacy")) return;

		const field = input.closest(".gfield");
		const picker = window.jQuery(input);

		// A partially loaded Gravity Forms datepicker can leave this class behind
		// without an attached jQuery UI instance, preventing focus from reopening it.
		if (input.classList.contains("hasDatepicker") && !picker.data("datepicker")) {
			input.classList.remove("hasDatepicker", "initialized");
		}

		if (picker.data("datepicker")) return;

		const idParts = input.id.match(/^input_(\d+)_(\d+)/);
		let options = {
			changeMonth: true,
			changeYear: true,
			dateFormat: input.classList.contains("ymd_dash") ? "yy-mm-dd" : (input.classList.contains("dmy") ? "dd/mm/yy" : "mm/dd/yy"),
			firstDay: 1,
			showOn: "focus",
		};

		if (idParts && window.gform?.applyFilters) {
			options = window.gform.applyFilters("gform_datepicker_options_pre_init", options, Number(idParts[1]), Number(idParts[2]));
		}

		picker.datepicker(options);
		input.classList.add("initialized");
		field?.querySelectorAll(".ui-datepicker-trigger").forEach((trigger) => trigger.setAttribute("aria-hidden", "true"));
		if (document.activeElement === input) picker.datepicker("show");
	});
};

initialiseFormSelects();
document.addEventListener("change", (event) => {
	const select = event.target.closest?.(".gform_wrapper select");
	if (select) select.classList.toggle("has-selection", select.value !== "");
});
document.addEventListener("focusin", (event) => {
	if (event.target.matches?.(".kickon-event-date input.gform-datepicker, .kickon-quote-event-date input.gform-datepicker, .kickon-event-quote--legacy .gfield--type-date input.gform-datepicker")) {
		initialiseFormDatepickers(event.target.closest(".gfield") || document);
	}
});
document.addEventListener("gform/post_render", (event) => {
	initialiseFormSelects(event.target);
	initialiseFormDatepickers(event.target);
});

if (reduceMotion || !("IntersectionObserver" in window)) {
	easeElements.forEach((element) => element.classList.add("show"));
} else {
	const easeObserver = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				entry.target.classList.add("show");
				observer.unobserve(entry.target);
			});
		},
		{ rootMargin: "0px 0px -10% 0px", threshold: 0.05 },
	);
	easeElements.forEach((element) => easeObserver.observe(element));
	window.requestAnimationFrame(() => {
		window.requestAnimationFrame(() => {
			compactHeroFollowupHeadings.forEach((heading) => {
				heading.classList.add("show");
				easeObserver.unobserve(heading);
			});
		});
	});
}

if (menuToggle && mobileMenu) {
	let closeTimer;
	const setMenu = (shouldOpen) => {
		window.clearTimeout(closeTimer);
		menuToggle.setAttribute("aria-expanded", String(shouldOpen));
		menuToggle.querySelector(".screen-reader-text").textContent = shouldOpen ? "Close menu" : "Open menu";

		if (shouldOpen) {
			mobileMenu.hidden = false;
			document.body.classList.add("menu-open");
			window.requestAnimationFrame(() => window.requestAnimationFrame(() => mobileMenu.classList.add("is-open")));
			return;
		}

		mobileMenu.classList.remove("is-open");
		closeTimer = window.setTimeout(() => {
			mobileMenu.hidden = true;
			document.body.classList.remove("menu-open");
		}, reduceMotion ? 0 : 560);
	};

	menuToggle.addEventListener("click", () => setMenu(menuToggle.getAttribute("aria-expanded") !== "true"));
	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape" && menuToggle.getAttribute("aria-expanded") === "true") {
			setMenu(false);
			menuToggle.focus();
		}
	});
	window.addEventListener("resize", () => {
		if (window.innerWidth >= 1400 && menuToggle.getAttribute("aria-expanded") === "true") setMenu(false);
	});
}

const isSubmenuControlLink = (link) => ["", "#"].includes(link.getAttribute("href") || "");

document.querySelectorAll(".site-header__nav .menu-item-has-children").forEach((item) => {
	const link = item.querySelector(":scope > a");
	const submenu = item.querySelector(":scope > .sub-menu");
	if (!link || !submenu || !isSubmenuControlLink(link)) return;

	link.setAttribute("role", "button");
	link.setAttribute("aria-haspopup", "true");
	link.setAttribute("aria-expanded", "false");

	const setSubmenu = (open) => {
		item.classList.toggle("is-open", open);
		link.setAttribute("aria-expanded", String(open));
		if (!open) link.blur();
	};

	link.addEventListener("click", (event) => {
		event.preventDefault();
		setSubmenu(!item.classList.contains("is-open"));
	});
	item.addEventListener("keydown", (event) => {
		if (event.key === "Escape") setSubmenu(false);
	});
	document.addEventListener("click", (event) => {
		if (!item.contains(event.target)) setSubmenu(false);
	});
});

document.querySelectorAll(".mobile-menu .menu-item-has-children").forEach((item) => {
	const link = item.querySelector(":scope > a");
	const submenu = item.querySelector(":scope > .sub-menu");
	if (!link || !submenu || item.querySelector(":scope > .submenu-toggle")) return;
	const toggle = document.createElement("button");
	toggle.type = "button";
	toggle.className = "submenu-toggle";
	toggle.setAttribute("aria-expanded", "false");
	toggle.setAttribute("aria-label", `Open ${link.textContent.trim()} submenu`);
	toggle.innerHTML = "<span aria-hidden=\"true\"></span>";
	submenu.setAttribute("aria-hidden", "true");
	submenu.inert = true;
	link.after(toggle);
	const toggleSubmenu = () => {
		const open = toggle.getAttribute("aria-expanded") === "true";
		if (!open) submenu.style.setProperty("--submenu-height", `${submenu.scrollHeight}px`);
		toggle.setAttribute("aria-expanded", String(!open));
		toggle.setAttribute("aria-label", `${open ? "Open" : "Close"} ${link.textContent.trim()} submenu`);
		submenu.setAttribute("aria-hidden", String(open));
		submenu.inert = open;
		item.classList.toggle("is-open", !open);
		if (isSubmenuControlLink(link)) link.setAttribute("aria-expanded", String(!open));
	};
	toggle.addEventListener("click", toggleSubmenu);
	if (isSubmenuControlLink(link)) {
		link.setAttribute("role", "button");
		link.setAttribute("aria-haspopup", "true");
		link.setAttribute("aria-expanded", "false");
		link.addEventListener("click", (event) => {
			event.preventDefault();
			toggleSubmenu();
		});
	}
});

document.querySelectorAll("[data-accordion-item]").forEach((item) => {
	const summary = item.querySelector("summary");
	const body = item.querySelector("[data-accordion-body]");
	if (!summary || !body) return;

	let animation;
	summary.addEventListener("click", (event) => {
		event.preventDefault();
		animation?.cancel();
		const opening = !item.open;

		if (reduceMotion) {
			item.open = opening;
			return;
		}

		if (opening) item.open = true;
		const startHeight = opening ? 0 : body.getBoundingClientRect().height;
		const endHeight = opening ? body.scrollHeight : 0;
		animation = body.animate(
			{
				height: [`${startHeight}px`, `${endHeight}px`],
				opacity: opening ? [0, 1] : [1, 0],
			},
			{ duration: 300, easing: "ease" },
		);
		animation.onfinish = () => {
			if (!opening) item.open = false;
			animation = null;
		};
	});
});

document.querySelectorAll("[data-carousel]").forEach((carousel) => {
	const track = carousel.querySelector("[data-carousel-track]");
	const previous = carousel.querySelector("[data-carousel-previous]");
	const next = carousel.querySelector("[data-carousel-next]");
	const progress = carousel.querySelector("[data-carousel-progress]");
	const controls = carousel.querySelector(".carousel-controls");
	const autoscroll = carousel.hasAttribute("data-carousel-autoscroll");
	if (!track) return;
	const originalItems = [...track.children];
	let autoscrollTimer;
	let loopResetTimer;
	let autoscrollLoopWidth = 0;
	const resetAutoscrollClones = () => {
		track.querySelectorAll(":scope > [data-carousel-clone]").forEach((clone) => clone.remove());
		autoscrollLoopWidth = 0;
		track.scrollLeft = 0;
	};

	const prepareAutoscroll = () => {
		if (!autoscroll || reduceMotion || originalItems.length < 2) return;
		if (!track.querySelector(":scope > [data-carousel-clone]")) {
			const clones = document.createDocumentFragment();
			for (let copy = 0; copy < 2; copy += 1) {
				originalItems.forEach((item) => {
					const clone = item.cloneNode(true);
					clone.dataset.carouselClone = "";
					clone.setAttribute("aria-hidden", "true");
					clone.inert = true;
					clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach((control) => control.setAttribute("tabindex", "-1"));
					clones.append(clone);
				});
			}
			track.append(clones);
		}
		const firstClone = track.querySelector(":scope > [data-carousel-clone]");
		autoscrollLoopWidth = firstClone ? firstClone.offsetLeft - originalItems[0].offsetLeft : 0;
	};
	prepareAutoscroll();
	const normaliseLoopPosition = () => {
		// Keep the viewport on the original, interactive cards. The duplicated
		// cards only exist to make the wrap seamless and are intentionally inert.
		if (autoscrollLoopWidth > 1 && track.scrollLeft >= autoscrollLoopWidth - 1) {
			track.scrollTo({ left: track.scrollLeft - autoscrollLoopWidth, behavior: "auto" });
		}
	};

	const updateCarousel = () => {
		const overflow = track.scrollWidth - track.clientWidth;
		const active = autoscrollLoopWidth > 1 || overflow > 1;
		track.classList.toggle("is-carousel-active", active);
		carousel.classList.toggle("is-carousel-active", active);
		if (controls) controls.hidden = !active;
		if (!active) track.scrollLeft = 0;
		const max = Math.max(autoscrollLoopWidth || overflow, 1);
		const position = autoscrollLoopWidth ? track.scrollLeft % autoscrollLoopWidth : track.scrollLeft;
		const percentage = Math.min(100, Math.max(0, (position / max) * 100));
		if (progress) progress.style.width = `${Math.max(8, percentage)}%`;
		if (previous) previous.disabled = !active;
		if (next) next.disabled = !active;
	};
	const move = (direction) => {
		const overflow = track.scrollWidth - track.clientWidth;
		if (overflow <= 1) return;
		if (autoscrollLoopWidth && direction < 0 && track.scrollLeft <= 1) track.scrollLeft += autoscrollLoopWidth;
		if (!autoscrollLoopWidth && direction > 0 && track.scrollLeft >= overflow - 1) {
			track.scrollTo({ left: 0, behavior: reduceMotion ? "auto" : "smooth" });
			updateCarousel();
			return;
		}
		if (!autoscrollLoopWidth && direction < 0 && track.scrollLeft <= 1) {
			track.scrollTo({ left: overflow, behavior: reduceMotion ? "auto" : "smooth" });
			updateCarousel();
			return;
		}
		const card = track.querySelector(":scope > *");
		const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0);
		track.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: "smooth" });
	};
	const stopAutoscroll = () => window.clearInterval(autoscrollTimer);
	const startAutoscroll = () => {
		stopAutoscroll();
		prepareAutoscroll();
		if (!autoscroll || reduceMotion || autoscrollLoopWidth <= 1 || document.hidden) return;
		autoscrollTimer = window.setInterval(() => move(1), 5000);
	};
	const restartAutoscroll = () => {
		stopAutoscroll();
		startAutoscroll();
	};
	previous?.addEventListener("click", () => {
		move(-1);
		restartAutoscroll();
	});
	next?.addEventListener("click", () => {
		move(1);
		restartAutoscroll();
	});
	carousel.addEventListener("focusin", stopAutoscroll);
	carousel.addEventListener("focusout", (event) => {
		if (!carousel.contains(event.relatedTarget)) startAutoscroll();
	});
	track.addEventListener("pointerdown", stopAutoscroll);
	track.addEventListener("pointerup", startAutoscroll);
	track.addEventListener("pointercancel", startAutoscroll);
	track.addEventListener("scroll", () => {
		updateCarousel();
		if (!autoscrollLoopWidth) return;
		window.clearTimeout(loopResetTimer);
		loopResetTimer = window.setTimeout(normaliseLoopPosition, 500);
	}, { passive: true });
	document.addEventListener("visibilitychange", () => document.hidden ? stopAutoscroll() : startAutoscroll());
	const refreshCarousel = (resetClones = false) => {
		if (resetClones && autoscroll) resetAutoscrollClones();
		prepareAutoscroll();
		updateCarousel();
		startAutoscroll();
	};
	window.addEventListener("resize", () => refreshCarousel(true));
	originalItems.forEach((item) => item.querySelectorAll("img").forEach((image) => image.addEventListener("load", () => refreshCarousel(true), { once: true })));
	if (!autoscroll && "ResizeObserver" in window) new ResizeObserver(refreshCarousel).observe(track);
	updateCarousel();
	startAutoscroll();
});

const heroVideoBreakpoint = window.matchMedia("(max-width: 767px)");
const heroVideoCleanups = new WeakMap();

const initialiseHeroVideo = async (video) => {
	const desktopUrl = video.dataset.videoUrl || "";
	const mobileUrl = video.dataset.videoMobileUrl || "";
	const videoUrl = heroVideoBreakpoint.matches && mobileUrl ? mobileUrl : desktopUrl || mobileUrl;
	if (!videoUrl || video.dataset.activeVideoUrl === videoUrl) return;

	heroVideoCleanups.get(video)?.();
	video.pause();
	video.classList.remove("is-ready");
	video.removeAttribute("src");
	video.load();
	video.dataset.activeVideoUrl = videoUrl;

	const isActive = () => !video.closest("[data-hero-slide]") || video.closest("[data-hero-slide]").classList.contains("is-active");
	const startWhenActive = () => {
		video.autoplay = isActive();
		if (isActive()) video.play().catch(() => {});
		else video.pause();
	};
	const revealVideo = () => {
		if (video.dataset.activeVideoUrl === videoUrl) video.classList.add("is-ready");
	};
	video.addEventListener("playing", revealVideo, { once: true });
	const playerConfig = document.querySelector("[data-video-modal]")?.dataset || {};

	try {
		if (/\.m3u8(?:$|\?)/i.test(videoUrl)) {
			await loadPlayerScript(playerConfig.hlsPlayerUrl);
			if (video.dataset.activeVideoUrl !== videoUrl) return;
			if (window.Hls?.isSupported()) {
				const hls = new window.Hls();
				hls.loadSource(videoUrl);
				hls.attachMedia(video);
				heroVideoCleanups.set(video, () => hls.destroy());
			} else if (video.canPlayType("application/vnd.apple.mpegurl")) {
				video.src = videoUrl;
				heroVideoCleanups.set(video, () => video.pause());
			} else {
				return;
			}
		} else if (/\.mpd(?:$|\?)/i.test(videoUrl)) {
			await loadPlayerScript(playerConfig.dashPlayerUrl);
			if (video.dataset.activeVideoUrl !== videoUrl || !window.dashjs?.MediaPlayer) return;
			const dashPlayer = window.dashjs.MediaPlayer().create();
			dashPlayer.initialize(video, videoUrl, false);
			heroVideoCleanups.set(video, () => dashPlayer.destroy());
		} else {
			video.src = videoUrl;
			heroVideoCleanups.set(video, () => video.pause());
		}
		startWhenActive();
	} catch (error) {
		console.error(error);
	}
};

const heroVideos = [...document.querySelectorAll("[data-hero-video]")];
heroVideos.forEach(initialiseHeroVideo);
heroVideoBreakpoint.addEventListener("change", () => heroVideos.forEach(initialiseHeroVideo));

document.querySelectorAll("[data-hero-scroll]").forEach((button) => {
	button.addEventListener("click", () => {
		const nextSection = button.closest(".hero")?.nextElementSibling;
		if (!nextSection) return;
		const headerBottom = Math.max(0, document.querySelector("[data-site-header]")?.getBoundingClientRect().bottom || 0);
		window.scrollTo({
			top: nextSection.getBoundingClientRect().top + window.scrollY - headerBottom,
			behavior: reduceMotion ? "auto" : "smooth",
		});
	});
});

document.querySelectorAll("[data-hero-carousel]").forEach((carousel) => {
	const slides = [...carousel.querySelectorAll("[data-hero-slide]")];
	const dots = [...carousel.querySelectorAll("[data-hero-dot]")];
	if (slides.length < 2) return;
	const duration = Math.max(1000, Number(carousel.dataset.heroDuration) || 6000);
	carousel.style.setProperty("--hero-slide-duration", `${duration}ms`);
	let active = 0;
	let timer;
	const restartProgress = () => {
		dots.forEach((dot) => dot.classList.remove("is-active"));
		const dot = dots[active];
		if (!dot) return;
		void dot.offsetWidth;
		dot.classList.add("is-active");
	};
	const show = (index) => {
		active = (index + slides.length) % slides.length;
		slides.forEach((slide, slideIndex) => {
			const selected = slideIndex === active;
			slide.classList.toggle("is-active", selected);
			slide.setAttribute("aria-hidden", String(!selected));
			slide.querySelectorAll("video").forEach((video) => {
				if (selected) video.play().catch(() => {});
				else video.pause();
			});
		});
		dots.forEach((dot, dotIndex) => dot.classList.toggle("is-current", dotIndex === active));
		restartProgress();
	};
	const start = () => {
		window.clearInterval(timer);
		if (!reduceMotion) timer = window.setInterval(() => show(active + 1), duration);
	};
	let pointerStart = null;
	carousel.addEventListener("pointerdown", (event) => {
		if (!event.isPrimary || ("mouse" === event.pointerType && 0 !== event.button) || event.target.closest("a, button, input, select, textarea")) return;
		pointerStart = { id: event.pointerId, x: event.clientX, y: event.clientY };
		carousel.setPointerCapture?.(event.pointerId);
	});
	carousel.addEventListener("pointerup", (event) => {
		if (!pointerStart || pointerStart.id !== event.pointerId) return;
		const deltaX = event.clientX - pointerStart.x;
		const deltaY = event.clientY - pointerStart.y;
		pointerStart = null;
		if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
		show(active + (deltaX < 0 ? 1 : -1));
		start();
	});
	carousel.addEventListener("pointercancel", () => { pointerStart = null; });
	show(0);
	start();
});

document.querySelectorAll("[data-auto-carousel]").forEach((carousel) => {
	const track = carousel.querySelector(".auto-carousel__track");
	if (!track) return;
	const seconds = Number(carousel.dataset.duration || 30);
	track.style.animationDuration = `${seconds}s`;
	const setupTicker = () => {
		if (track.dataset.duplicated !== "true" && track.scrollWidth > carousel.clientWidth) {
			[...track.children].forEach((item) => {
				const clone = item.cloneNode(true);
				clone.setAttribute("aria-hidden", "true");
				track.append(clone);
			});
			track.dataset.duplicated = "true";
		}
		carousel.classList.toggle("is-overflowing", track.dataset.duplicated === "true" && !matchMedia("(prefers-reduced-motion: reduce)").matches);
	};
	setupTicker();
	window.addEventListener("resize", setupTicker);
});

document.querySelectorAll("[data-staggered-gallery]").forEach((gallery) => {
	const figures = [...gallery.querySelectorAll(":scope > figure")];
	let frame;
	let observedWidth = 0;

	const layoutGallery = () => {
		window.cancelAnimationFrame(frame);
		frame = window.requestAnimationFrame(() => {
			const styles = getComputedStyle(gallery);
			const columns = window.matchMedia("(min-width: 768px)").matches ? 3 : 2;
			const gap = parseFloat(styles.columnGap) || 0;
			const columnWidth = (gallery.clientWidth - gap * (columns - 1)) / columns;
			const columnHeights = Array(columns).fill(0);

			figures.forEach((figure) => {
				const shortestColumn = columnHeights.indexOf(Math.min(...columnHeights));
				figure.style.position = "absolute";
				figure.style.width = `${columnWidth}px`;
				figure.style.left = `${shortestColumn * (columnWidth + gap)}px`;
				figure.style.top = `${columnHeights[shortestColumn]}px`;
				columnHeights[shortestColumn] += figure.getBoundingClientRect().height + gap;
			});

			gallery.style.height = `${Math.max(0, ...columnHeights) - gap}px`;
		});
	};

	figures.forEach((figure) => {
		figure.querySelectorAll("img").forEach((image) => {
			if (!image.complete) image.addEventListener("load", layoutGallery, { once: true });
		});
	});
	if ("ResizeObserver" in window) {
		new ResizeObserver((entries) => {
			const width = entries[0]?.contentRect.width || 0;
			if (Math.abs(width - observedWidth) < 1) return;
			observedWidth = width;
			layoutGallery();
		}).observe(gallery);
	}
	window.addEventListener("resize", layoutGallery);
	window.addEventListener("load", layoutGallery, { once: true });
	layoutGallery();
});

const videoModal = document.querySelector("[data-video-modal]");
if (videoModal) {
	const player = videoModal.querySelector("[data-video-modal-player]");
	const title = videoModal.querySelector("[data-video-modal-title]");
	const close = videoModal.querySelector("[data-video-modal-close]");
	let activeTrigger;
	let activePlayerCleanup;

	const createVideo = (videoTitle) => {
		const video = document.createElement("video");
		video.controls = true;
		video.autoplay = true;
		video.playsInline = true;
		video.setAttribute("aria-label", videoTitle);
		return video;
	};

	const createPlayer = async (videoUrl, videoTitle) => {
		let url;
		try {
			url = new URL(videoUrl);
		} catch {
			return null;
		}

		const hostname = url.hostname.replace(/^www\./, "");
		const vimeoMatch = hostname === "vimeo.com"
			? url.pathname.match(/^\/(\d+)/)
			: hostname === "player.vimeo.com"
				? url.pathname.match(/^\/video\/(\d+)/)
				: null;
		let youtubeId = "";
		if (hostname === "youtu.be") youtubeId = url.pathname.split("/").filter(Boolean)[0] || "";
		if (["youtube.com", "m.youtube.com", "youtube-nocookie.com"].includes(hostname)) {
			youtubeId = url.searchParams.get("v") || url.pathname.match(/^\/(?:embed|shorts)\/([^/?]+)/)?.[1] || "";
		}

		if (/\.(mp4|webm)(?:$|\?)/i.test(url.href)) {
			const video = createVideo(videoTitle);
			video.src = url.href;
			return { media: video, destroy: () => video.pause() };
		}

		if (/\.m3u8(?:$|\?)/i.test(url.href)) {
			const video = createVideo(videoTitle);
			await loadPlayerScript(videoModal.dataset.hlsPlayerUrl);
			if (window.Hls?.isSupported()) {
				const hls = new window.Hls();
				hls.loadSource(url.href);
				hls.attachMedia(video);
				return { media: video, destroy: () => hls.destroy() };
			}
			if (video.canPlayType("application/vnd.apple.mpegurl")) {
				video.src = url.href;
				return { media: video, destroy: () => video.pause() };
			}
			return null;
		}

		if (/\.mpd(?:$|\?)/i.test(url.href)) {
			await loadPlayerScript(videoModal.dataset.dashPlayerUrl);
			if (!window.dashjs?.MediaPlayer) return null;
			const video = createVideo(videoTitle);
			const dashPlayer = window.dashjs.MediaPlayer().create();
			dashPlayer.initialize(video, url.href, true);
			return { media: video, destroy: () => dashPlayer.destroy() };
		}

		const iframe = document.createElement("iframe");
		if (vimeoMatch) {
			const playerUrl = new URL(`https://player.vimeo.com/video/${vimeoMatch[1]}`);
			url.searchParams.forEach((value, key) => playerUrl.searchParams.set(key, value));
			playerUrl.searchParams.set("autoplay", "1");
			iframe.src = playerUrl.href;
		} else if (youtubeId) iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1`;
		else return null;
		iframe.title = videoTitle;
		iframe.allow = "autoplay; fullscreen; picture-in-picture";
		iframe.allowFullscreen = true;
		iframe.referrerPolicy = "strict-origin-when-cross-origin";
		return { media: iframe, destroy: () => iframe.removeAttribute("src") };
	};

	const stopVideo = () => {
		activePlayerCleanup?.();
		activePlayerCleanup = null;
		player?.replaceChildren();
		document.body.classList.remove("video-open");
		activeTrigger?.focus();
		activeTrigger = null;
	};

	document.querySelectorAll("[data-video-modal-trigger]").forEach((trigger) => {
		trigger.addEventListener("click", async (event) => {
			event.preventDefault();
			const fallbackUrl = trigger instanceof HTMLAnchorElement ? trigger.href : "";
			const videoTitle = trigger.dataset.videoTitle || "Video";
			let playerConfig;
			try {
				playerConfig = await createPlayer(trigger.dataset.videoUrl, videoTitle);
			} catch (error) {
				console.error(error);
				if (fallbackUrl) window.location.assign(fallbackUrl);
				return;
			}
			if (!playerConfig || !player) {
				if (fallbackUrl) window.location.assign(fallbackUrl);
				return;
			}
			activeTrigger = trigger;
			activePlayerCleanup = playerConfig.destroy;
			title.textContent = videoTitle;
			player.replaceChildren(playerConfig.media);
			videoModal.showModal();
			document.body.classList.add("video-open");
			close?.focus();
		});
	});

	close?.addEventListener("click", () => videoModal.close());
	videoModal.addEventListener("click", (event) => {
		if (event.target === videoModal) videoModal.close();
	});
	videoModal.addEventListener("close", stopVideo);
}

const galleryLightbox = document.querySelector("[data-gallery-lightbox]");
if (galleryLightbox) {
	const lightboxImage = galleryLightbox.querySelector("[data-gallery-lightbox-image]");
	const lightboxCaption = galleryLightbox.querySelector("[data-gallery-lightbox-caption]");
	const close = galleryLightbox.querySelector("[data-gallery-lightbox-close]");
	let activeTrigger = null;

	const showImage = (trigger) => {
		lightboxImage.src = trigger.dataset.gallerySrc;
		lightboxImage.alt = trigger.dataset.galleryAlt || "";
		lightboxCaption.textContent = trigger.dataset.galleryCaption || "";
		lightboxCaption.hidden = !lightboxCaption.textContent;
	};

	document.querySelectorAll(".image-gallery").forEach((gallery) => {
		const triggers = [...gallery.querySelectorAll("[data-gallery-lightbox-trigger]")];
		triggers.forEach((trigger) => {
			trigger.addEventListener("click", () => {
				activeTrigger = trigger;
				showImage(trigger);
				galleryLightbox.showModal();
				document.body.classList.add("lightbox-open");
				close?.focus();
			});
		});
	});

	close?.addEventListener("click", () => galleryLightbox.close());
	galleryLightbox.addEventListener("click", (event) => {
		if (event.target === galleryLightbox) galleryLightbox.close();
	});
	galleryLightbox.addEventListener("close", () => {
		document.body.classList.remove("lightbox-open");
		lightboxImage.removeAttribute("src");
		activeTrigger?.focus();
	});
}

document.querySelectorAll("[data-sports-schedule]").forEach((schedule) => {
	const search = schedule.querySelector("[data-sports-search]");
	const sport = schedule.querySelector("[data-sports-code]");
	const date = schedule.querySelector("[data-sports-date]");
	const clear = schedule.querySelector("[data-sports-clear]");
	const items = [...schedule.querySelectorAll("[data-sports-item]")];
	const featured = schedule.querySelector(".sports-featured[data-sports-item]");
	const featuredTitle = schedule.querySelector("[data-sports-featured-title]");
	const loadMoreTrigger = schedule.querySelector("[data-sports-load-more]");
	const batchSize = Math.max(1, Number(schedule.dataset.sportsBatchSize) || 12);
	let visibleLimit = items.filter((item) => item.dataset.sportsDefaultVisible !== "false").length;
	const empty = document.createElement("p");
	const sportSlug = (value) => value.trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
	const requestedSport = sportSlug(new URLSearchParams(window.location.search).get("sport") || "");
	empty.className = "sports-empty";
	empty.hidden = true;
	empty.textContent = "No fixtures match those filters.";
	schedule.querySelector(".sports-days")?.after(empty);

	if (sport && requestedSport) {
		const requestedOption = [...sport.options].find((option) => (
			option.value && (sportSlug(option.value) === requestedSport || sportSlug(option.textContent) === requestedSport)
		));
		if (requestedOption) sport.value = requestedOption.value;
	}

	if (date && window.jQuery?.fn?.datepicker) {
		const datepicker = window.jQuery(date);
		datepicker.datepicker({
			changeMonth: true,
			changeYear: true,
			dateFormat: "dd/mm/yy",
			firstDay: 1,
			onSelect: (_value, instance) => {
				const selected = window.jQuery.datepicker.parseDate("dd/mm/yy", instance.input.val());
				date.dataset.filterDate = window.jQuery.datepicker.formatDate("yy-mm-dd", selected);
				date.dispatchEvent(new Event("change", { bubbles: true }));
			},
		});
		date.addEventListener("click", () => datepicker.datepicker("show"));
	}

	const updateFixtureLayout = (group) => {
		const visible = [...group.querySelectorAll(".fixture:not([hidden])")];
		const lastRowStart = Math.max(visible.length - (visible.length % 2 || 2), 0);

		visible.forEach((item, index) => {
			item.classList.toggle("fixture--right", index % 2 === 1);
			item.classList.toggle("fixture--after-first-row", index >= 2);
			item.classList.toggle("fixture--last-row", index >= lastRowStart);
			item.classList.toggle("fixture--last-odd", visible.length % 2 === 1 && index === visible.length - 1);
		});
	};

	const filterFixtures = () => {
		const query = search?.value.trim().toLowerCase() || "";
		const code = sport?.value || "";
		const day = date?.dataset.filterDate || "";
		const filtering = Boolean(query || code || day);
		items.forEach((item, index) => {
			const matches = !(
				(query && !item.dataset.search.includes(query)) ||
				(code && item.dataset.sport !== code) ||
				(day && item.dataset.date !== day)
			);
			item.hidden = !matches || (!filtering && index >= visibleLimit);
		});
		schedule.querySelectorAll("[data-sports-day]").forEach((group) => {
			updateFixtureLayout(group);
			group.hidden = !group.querySelector("[data-sports-item]:not([hidden])");
		});
		if (featuredTitle) {
			featuredTitle.hidden = !featured || featured.hidden;
			if (!featuredTitle.hidden && code) {
				featuredTitle.textContent = `Upcoming ${sport.options[sport.selectedIndex]?.text || "Sports"}`;
			}
		}
		empty.hidden = items.some((item) => !item.hidden);
		if (loadMoreTrigger) loadMoreTrigger.hidden = filtering || visibleLimit >= items.length;
	};

	if (loadMoreTrigger && "IntersectionObserver" in window) {
		const loadMoreObserver = new IntersectionObserver((entries) => {
			if (!entries.some((entry) => entry.isIntersecting) || loadMoreTrigger.hidden) return;
			visibleLimit = Math.min(items.length, visibleLimit + batchSize);
			filterFixtures();
		}, { rootMargin: "400px 0px" });
		loadMoreObserver.observe(loadMoreTrigger);
	} else if (loadMoreTrigger) {
		visibleLimit = items.length;
	}

	const updateSportQuery = () => {
		if (!sport) return;
		const url = new URL(window.location.href);
		const selectedOption = sport.options[sport.selectedIndex];
		if (sport.value && selectedOption) url.searchParams.set("sport", sportSlug(selectedOption.textContent));
		else url.searchParams.delete("sport");
		window.history.replaceState({}, "", url);
	};

	search?.addEventListener("input", filterFixtures);
	sport?.addEventListener("change", () => {
		updateSportQuery();
		filterFixtures();
	});
	date?.addEventListener("change", () => {
		if (!date.value) {
			date.dataset.filterDate = "";
		} else if (window.jQuery?.datepicker) {
			try {
				const selected = window.jQuery.datepicker.parseDate("dd/mm/yy", date.value);
				date.dataset.filterDate = window.jQuery.datepicker.formatDate("yy-mm-dd", selected);
			} catch (_error) {
				date.dataset.filterDate = "";
			}
		}
		filterFixtures();
	});
	clear?.addEventListener("click", () => {
		if (search) search.value = "";
		if (sport) sport.value = "";
		if (date) {
			date.value = date.dataset.datePlaceholder || "";
			date.dataset.filterDate = "";
			if (window.jQuery?.fn?.datepicker) window.jQuery(date).datepicker("setDate", null);
			date.value = date.dataset.datePlaceholder || "";
		}
		updateSportQuery();
		filterFixtures();
	});
	filterFixtures();
});

const eventQuoteFormIds = new Set();

const updateLegacyEventQuote = (form) => {
	const fieldValue = (fieldId) => form.querySelector(`[name="input_${fieldId}"]:checked`)?.value
		?? form.querySelector(`[name="input_${fieldId}"]`)?.value
		?? "";
	const optionRates = (fieldId) => Object.fromEntries(
		[...form.querySelectorAll(`[name="input_${fieldId}"] option`)].map((option) => [option.textContent.trim(), Number(option.value) || 0]),
	);
	const foodRates = optionRates(73);
	const sessionRates = optionRates(74);
	const drinksRates = optionRates(75);
	const spiritsRates = optionRates(76);
	const occasion = fieldValue(1) || "default";
	const eventStyle = fieldValue(4) || "default";
	const occasionKey = ["Corporate", "Meeting / Seminar"].includes(occasion) ? occasion : "default";
	const foodRate = foodRates[`${occasionKey}_${eventStyle}`] ?? foodRates.default_default ?? 0;
	const sessionRate = occasion === "Meeting / Seminar" ? (sessionRates[fieldValue(20)] ?? 0) : 0;
	const standardDrinks = fieldValue(21);
	const meetingDrinks = fieldValue(94);
	const drinksRate = occasion === "Meeting / Seminar"
		? ((drinksRates[meetingDrinks] ?? 0) / 5) * 2
		: (drinksRates[standardDrinks] ?? 0);
	const spiritsRate = standardDrinks === "Drinks Package" ? (spiritsRates[fieldValue(23)] ?? 0) : 0;
	const guests = fieldValue(3);
	const paxMessage = form.querySelector(".pax-message");
	if (paxMessage && guests) {
		const count = document.createElement("strong");
		count.textContent = guests;
		paxMessage.replaceChildren(
			document.createTextNode("To give you an indicative quote for your event for "),
			count,
			document.createTextNode(" people, we’ve based the pricing on the following:"),
		);
	}
	const changes = [];

	[[65, foodRate], [66, sessionRate], [67, drinksRate], [68, spiritsRate]].forEach(([fieldId, value]) => {
		const input = form.querySelector(`[name="input_${fieldId}"]`);
		if (!input || Number(input.value) === Number(value)) return;
		input.value = value;
		changes.push(input);
	});
	changes.forEach((input) => input.dispatchEvent(new Event("change", { bubbles: true })));
};

const updateEventQuote = (form) => {
	if (!form?.classList.contains("kickon-event-quote")) return;
	eventQuoteFormIds.add(Number(form.dataset.formid || form.id?.match(/\d+$/)?.[0] || 0));
	const firstFooter = form.querySelector(".gform_page:first-of-type .gform_page_footer");
	if (firstFooter && !firstFooter.querySelector(".kickon-quote-back-placeholder")) {
		const back = document.createElement("a");
		back.href = "/";
		back.className = "gform_previous_button kickon-quote-back-placeholder";
		back.textContent = "Back to main site";
		firstFooter.prepend(back);
	}
	let progress = form.querySelector(".kickon-quote-progress");
	if (!progress) {
		progress = document.createElement("div");
		progress.className = "kickon-quote-progress";
		progress.setAttribute("aria-hidden", "true");
		progress.innerHTML = "<span></span>";
		form.querySelector(".gform-body")?.before(progress);
	}
	const pages = [...form.querySelectorAll(".gform_page")];
	const currentPage = Math.max(0, pages.findIndex((page) => !page.hidden && getComputedStyle(page).display !== "none"));
	const progressValue = currentPage === 0 ? "8px" : `${(currentPage / Math.max(pages.length - 1, 1)) * 98}%`;
	progress.querySelector("span")?.style.setProperty("width", progressValue);
	if (form.classList.contains("kickon-event-quote--legacy")) {
		updateLegacyEventQuote(form);
		return;
	}
	const guests = Number(form.querySelector(".kickon-quote-guests input, .kickon-quote-guests select")?.value || 0);
	const foodChoice = form.querySelector(".kickon-quote-food input:checked");
	const drinksChoice = form.querySelector(".kickon-quote-drinks input:checked");
	// These rates mirror the hidden settings fields in the exported live form.
	const foodRates = { Standing: 36, Platters: 25, Set: 69 };
	const drinksRates = { "Drinks Package": 48, "Bar Tab": 25, None: 0 };
	const foodRate = Number(foodRates[foodChoice?.value] || 0);
	const drinksRate = Number(drinksRates[drinksChoice?.value] || 0);
	const foodTotal = guests * foodRate;
	const drinksTotal = guests * drinksRate;
	const total = foodTotal + drinksTotal;
	const currency = new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: 0 });
	const setText = (selector, value) => form.querySelectorAll(selector).forEach((element) => { element.textContent = value; });
	const setValue = (selector, value) => form.querySelectorAll(selector).forEach((field) => { field.value = value; });

	setText("[data-quote-guests]", guests || 0);
	setText("[data-quote-food]", currency.format(foodTotal));
	setText("[data-quote-drinks]", currency.format(drinksTotal));
	setText("[data-quote-total]", currency.format(total));
	setText("[data-quote-food-description]", foodChoice ? `${foodChoice.nextElementSibling?.textContent?.trim() || "Food"} at ${currency.format(foodRate)} per person.` : "");
	setText("[data-quote-drinks-description]", drinksChoice ? `${drinksChoice.nextElementSibling?.textContent?.trim() || "Drinks"} at ${currency.format(drinksRate)} per person.` : "");
	setValue(".kickon-quote-food-total input", foodTotal);
	setValue(".kickon-quote-drinks-total input", drinksTotal);
	setValue(".kickon-quote-event-total input", total);
};

const initialiseEventQuotes = () => document.querySelectorAll("form.kickon-event-quote").forEach(updateEventQuote);
const handleEventQuotePageChange = (event) => {
	initialiseEventQuotes();
	const form = event?.target?.closest?.("form.kickon-event-quote") || document.querySelector("form.kickon-event-quote");
	if (!form) return;
	initialiseFormSelects(form);
	window.requestAnimationFrame(() => {
		window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
	});
};
const scrollEventQuoteToTop = () => {
	window.requestAnimationFrame(() => {
		window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" });
	});
};
document.addEventListener("input", (event) => updateEventQuote(event.target.closest("form.kickon-event-quote")));
document.addEventListener("change", (event) => updateEventQuote(event.target.closest("form.kickon-event-quote")));
document.addEventListener("gform/post_init", initialiseEventQuotes);
document.addEventListener("gform/ajax/post_page_change", handleEventQuotePageChange);
window.jQuery?.(document).on("gform_page_loaded", handleEventQuotePageChange);
window.jQuery?.(document).on("gform_confirmation_loaded", (_event, formId) => {
	if (eventQuoteFormIds.has(Number(formId))) scrollEventQuoteToTop();
});
initialiseEventQuotes();
